import { useCallback, useEffect, useState } from 'react';

// Summary: POS connectivity truth from navigator online/offline events plus SSE stream health.
export function useConnectionStatus(): {
  isOffline: boolean;
  markStreamDown: () => void;
  markStreamAlive: () => void;
} {
  const [isBrowserOffline, setIsBrowserOffline] = useState(
    () => typeof navigator !== 'undefined' && navigator.onLine === false,
  );
  const [isStreamDown, setIsStreamDown] = useState(false);

  useEffect(() => {
    const goOffline = () => setIsBrowserOffline(true);
    // Regained network clears both signals; a live SSE reconnect also clears via markStreamAlive.
    const goOnline = () => {
      setIsBrowserOffline(false);
      setIsStreamDown(false);
    };
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  const markStreamDown = useCallback(() => setIsStreamDown(true), []);
  const markStreamAlive = useCallback(() => setIsStreamDown(false), []);

  return { isOffline: isBrowserOffline || isStreamDown, markStreamDown, markStreamAlive };
}
